import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { initials } from "../format";

/** Initials on the brand colour (§1.3). Decorative: the name is always next to it. */
export function Avatar({ name, size = 36, className }: { name?: string | null; size?: number; className?: string }) {
  return (
    <span aria-hidden="true" className={clsx("inline-flex flex-none items-center justify-center rounded-full bg-brand-soft font-bold text-brand-text", className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}>{initials(name ?? "")}</span>
  );
}

/** Name + one secondary line (title, org unit or e-mail), optionally an in-app link. */
export function PersonLine({ person, secondary, to, size = 36, className }: { person: { displayName: string; email?: string | null }; secondary?: ReactNode; to?: string; size?: number; className?: string }) {
  const body = (
    <>
      <Avatar name={person.displayName} size={size} />
      <span className="min-w-0">
        <span className="block truncate font-semibold text-fg">{person.displayName}</span>
        {(secondary ?? person.email) && <span className="block truncate text-small text-fg-3">{secondary ?? person.email}</span>}
      </span>
    </>
  );
  const cls = clsx("inline-flex min-w-0 max-w-full items-center gap-2.5 text-left", className);
  return to ? <Link to={to} className={clsx(cls, "no-underline hover:underline")}>{body}</Link> : <span className={cls}>{body}</span>;
}
